export default __webpack_public_path__ + "static/media/doctor_new.6dfbdc90.png";